module.exports = __webpack_public_path__ + "img/diagnosis.5d2251e7.jpg";